import React from 'react';
import styles from './style.css';

class BusinessInfoDetail extends React.Component {
  render() {
    const { isOwner, businessKyb, onClickUpdateBusinessInfo } = this.props;
    return (
      <div className={`row ${styles['pt-25']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>
            BUSINESS INFO
            {isOwner && (
              <button
                className="btn btn-link pull-right"
                onClick={onClickUpdateBusinessInfo}
              >
                Edit
              </button>
            )}
          </div>
          <div className={styles['text-label']}>
            Business Name
            <div className={`pull-right ${styles['text-description']}`}>
              {businessKyb.name}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={`${styles['text-label']} ${styles['image-block']}`}>
            Business Address
            <div className={`pull-right ${styles['text-description']}`}>
              {businessKyb.address}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            Province
            <div className={`pull-right ${styles['text-description']}`}>
              {businessKyb.province}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            City / Kabupaten
            <div className={`pull-right ${styles['text-description']}`}>
              {businessKyb.city}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            Kecamatan
            <div className={`pull-right ${styles['text-description']}`}>
              {businessKyb.kecamatan}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            Postal Code
            <div className={`pull-right ${styles['text-description']}`}>
              {businessKyb.postal_code}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
      </div>
    );
  }
}

export default BusinessInfoDetail;
